<div class="item-page-field">
  <ds-metadata-field-wrapper [label]="label | translate">
    <ng-container *ngFor="let mdValue of values; let last = last">
      <span class="dont-break-out preserve-line-breaks">{{ getLanguageName(mdValue.value) }}</span>
      <span class="separator" *ngIf="!last" [innerHTML]="separator"></span>
    </ng-container>
  </ds-metadata-field-wrapper>
</div>
